import { englishIqStoredSessionSchema } from '@repo/sdk';
import { ENGLISH_IQ_SESSION_STORAGE_KEY } from './english-iq-session-storage-key';
import { englishIqStoredFlowSchema, type IEnglishIqStoredFlow } from './english-iq-stored-session';

function hasExpired(flow: IEnglishIqStoredFlow, now: number): boolean {
  if (
    flow.phase === 'completing' ||
    flow.phase === 'result' ||
    (flow.phase === 'milestone' && !flow.session.milestone.canContinue)
  ) {
    return false;
  }
  return flow.session.expiresAt <= now;
}

function migrateLegacySession(value: unknown): IEnglishIqStoredFlow | null {
  const parsed = englishIqStoredSessionSchema.safeParse(value);
  if (!parsed.success) {
    return null;
  }
  if (parsed.data.milestone) {
    return {
      phase: 'milestone',
      session: { ...parsed.data, milestone: parsed.data.milestone },
    };
  }
  return { phase: 'question', session: { ...parsed.data, milestone: null } };
}

export function readEnglishIqSession(
  locale: string,
  now = Date.now(),
): IEnglishIqStoredFlow | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const value = JSON.parse(localStorage.getItem(ENGLISH_IQ_SESSION_STORAGE_KEY) ?? 'null');
    const parsed = englishIqStoredFlowSchema.safeParse(value);
    const flow = parsed.success ? parsed.data : migrateLegacySession(value);
    const flowLocale =
      flow?.phase === 'question' || flow?.phase === 'milestone'
        ? flow.session.locale
        : flow?.locale;
    if (!flow || flowLocale !== locale || hasExpired(flow, now)) {
      return null;
    }
    return flow;
  } catch {
    return null;
  }
}
